import { Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";

import { useAdvisoryCaseQuery } from "AdvisoryManagement/Api/Queries/useAdvisoryCaseQuery";
import { ClientDetail } from "AdvisoryManagement/Components/Client/ClientDetail";
import { AdvisoryManagementLayout } from "AdvisoryManagement/Components/Layouts/AdvisoryManagementLayout";
import { Error404Page } from "Infrastructure/Pages/Error404Page";
import { MainLayout } from "Shared/Layouts/MainLayout";

const AdvisoryManagementPage = () => {
	const { advisoryCaseId } = useParams<{ advisoryCaseId: string }>();

	const { data, isLoading, error } = useAdvisoryCaseQuery(advisoryCaseId);

	// Loading state
	if (isLoading) {
		return (
			<MainLayout title="Načítání...">
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						minHeight: "50vh",
					}}
				>
					<CircularProgress />
				</Box>
			</MainLayout>
		);
	}

	// Error or no data → 404
	if (error || !data) {
		return (
			<MainLayout title="Stránka nenalezena">
				<Error404Page />
			</MainLayout>
		);
	}

	// Success → render ClientDetail
	return (
		<MainLayout title="Správce obchodů">
			<AdvisoryManagementLayout>
				<ClientDetail />
			</AdvisoryManagementLayout>
		</MainLayout>
	);
};

export default AdvisoryManagementPage;
